const QA2_API = "hello-gateway-qa2-gcp.gdn-app.com";
const PROD_API = "hello.blibli.com"
const PROD = "helloofficialstore.myshopify.com";
const env = Shopify.shop === PROD ? PROD_API : QA2_API;
const hmacKey = Shopify.shop === PROD ? "4068ab29c95a3ae364d12d33d2e62aa375bb02d7d0237f090936e64a2a8ee5b1": "5eba9ffcb69849d50d9f99b5d5998ba6e2d376bc94c54cc5e841fe917da85b62"

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if(summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

function showToast({ message, type, width }) {
  const toastElement = document.createElement('div');
  toastElement.classList.add('blu-toast');
  if (type) {
    toastElement.classList.add(`b-${type}`);
  }
  toastElement.innerHTML = `
    <div class="blu-toast__content">
      <div class="blu-toast__content--desc" role="alert">
        ${message}
      </div>
    </div>
  `;
  width ? toastElement.style.width = width:"" ; 
  document.body.appendChild(toastElement);
  setTimeout(function () {
    toastElement.remove();
  }, 3000);
}

function getFormattedInstallmentPrice(price, month = 1200) {
  const pricePerMonth = Math.floor(price/month)
  const formattedPrice = new Intl.NumberFormat('id-ID',
    { style: 'currency', currency: 'IDR', minimumFractionDigits: 0 }
  ).format(pricePerMonth);
  return formattedPrice;
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch(e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if(navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true })

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if(!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if(isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach(details => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach(submenu => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.getElementById('shopify-section-header');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
  }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this, false)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerdown', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('pointerdown', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class InstallmentModalOpener extends ModalOpener {
  constructor() {
    super();
  }
  static get observedAttributes() {
    return ["data-installment-scheme"];
  }
  setTextFromInstallmentSchemes() {
    const productOriginalPrice = document.getElementById("productPrice");
    const variantInput = document.querySelector('variant-radios');
    if (variantInput && !variantInput.currentVariant) {
      // there are multiple variants but the current variant is not activated yet, so skip now and wait for the next call when it's activated
      return;
    }
    const price = (variantInput?.currentVariant?.price
      ?? document.querySelector('.price')?.dataset.price
      ?? productOriginalPrice.getAttribute("data-product-price"))

    /*
      from this expected format, we need to get the maximum free installment frequency
      freeInstallments: "12:1,24:2" --> [1,2] --> max is 2, show text for free installment
      freeInstallments: "" --> [0] --> max is 0, indicates no free installment is available, show regular text
    */
    const maxFreeInstallmentFrequencyPerScheme = this.installmentSchemes
      .map(scheme => {
        if (!scheme.freeInstallments || scheme.freeInstallments.trim().length === 0) {
          return 0
        }
        try {
          const tenorFreqPairs = scheme.freeInstallments.split(",");
          const frequencies = tenorFreqPairs.map(tenorFreqPair => parseInt(tenorFreqPair.trim().split(":")[1]))
          return Math.max(...frequencies)
        } catch (error) {
          // error due to wrong input format in the theme customization
          return 0
        }
      });
    const maxFreeInstallmentFrequency = Math.max(...maxFreeInstallmentFrequencyPerScheme);
    const maxMonthsPerScheme = this.installmentSchemes
      .map(scheme => parseInt(Math.max(...scheme.installmentPeriod.split(","))))
    const maxMonths = Math.max(...maxMonthsPerScheme);
    const installmentPriceStr = getFormattedInstallmentPrice(price, maxMonths * 100);
  }
  setInstallmentSchemes() {
    this.installmentSchemes = JSON.parse(document.querySelector(`script[data-installment-scheme="${this.dataset.installmentScheme}"]`).innerHTML);
    if (this.installmentSchemes.length) {
      this.setTextFromInstallmentSchemes();
      this.classList.remove('hidden');
    } else {
      this.classList.add('hidden');
    }
  }
  setInstallmentInfoTickerVisible(visible) {
    document.querySelectorAll('installments-info-ticker').forEach(ticker => {
      if (visible) {
        ticker.classList.remove('hidden');
      } else {
        ticker.classList.add('hidden');
      }
    })
  }
  connectedCallback() {
    this.setInstallmentSchemes();
  }
  attributeChangedCallback(changedAttributeName) {
    if (changedAttributeName === "data-installment-scheme") {
      this.setInstallmentSchemes();
    }
  }
}
customElements.define('installment-modal-opener', InstallmentModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');
    this.sliderPage = this.slider.getAttribute('page')
    this.isMobileSlider = window.matchMedia('(max-width: 749px)').matches

    if (!this.slider || !this.nextButton) return;
    
    this.initPages();
    
    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));

    const sliderButtons = this.querySelectorAll('.slider-counter__link')
    sliderButtons.forEach(dot => {
      dot.addEventListener('click', () => this.moveActiveThumbnail(dot))
    })
  }

  moveActiveThumbnail(dot) {
    this.sliderItems = this.querySelectorAll('[id^="Slide-template"]');
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    
    const tabIndex = dot.getAttribute('tabIndex')
    
    const previousPage = this.currentPage;
    this.currentPage = tabIndex;

    this.updateSliderControlButtons();

    this.sliderItems[tabIndex-1].scrollIntoView({ 
      behavior: 'smooth', 
      block: 'nearest', 
      inline: 'nearest'
    });

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(new CustomEvent('slideChanged', { detail: {
        currentPage: this.currentPage,
        currentElement: this.sliderItemsToShow[this.currentPage - 1]
      }}));
    }
  }
  
  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    
    if (this.sliderItemsToShow.length < 2) return;
    
    if (this.sliderPage === 'pdp' && !this.isMobileSlider) {
      this.sliderItemOffset = this.sliderItemsToShow[1].offsetTop - this.sliderItemsToShow[0].offsetTop;
      this.slidesPerPage = Math.floor((this.slider.clientHeight - this.sliderItemsToShow[0].offsetTop) / this.sliderItemOffset);
    } else {
      this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
      this.slidesPerPage = Math.floor((this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset);
    }
    
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    this.updateSliderControlButtons();
    
    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(new CustomEvent('slideChanged', { detail: {
        currentPage: this.currentPage,
        currentElement: this.sliderItemsToShow[this.currentPage - 1]
      }}));
    }

    if (this.enableSliderLooping) return;

    const sliderComponentItemsTotalWidth = this.sliderItemsToShow[0].clientWidth * this.sliderItemsToShow.length
    if(sliderComponentItemsTotalWidth <= this.clientWidth) {
      this.prevButton.setAttribute('disabled', 'disabled');
      this.prevButton.style.visibility = 'hidden';
      this.nextButton.setAttribute('disabled', 'disabled');
      this.nextButton.style.visibility = 'hidden';
      return
    }

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && (this.slider.scrollLeft === 0 || this.slider.scrollTop === 0)) {
      this.prevButton.setAttribute('disabled', 'disabled');
      this.prevButton.style.visibility = 'hidden';     
    } else {
      this.prevButton.removeAttribute('disabled');
      if (!this.isMobileSlider) {
        this.prevButton.style.visibility = 'visible';
      }
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1], -5)) {
      this.nextButton.setAttribute('disabled', 'disabled');
      this.nextButton.style.visibility = 'hidden';
    } else {
      this.nextButton.removeAttribute('disabled');
      if (!this.isMobileSlider) {
        this.nextButton.style.visibility = 'visible';
      }
    }
  }

  updateSliderControlButtons() {
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');

    if (!this.sliderControlButtons.length) return;
    this.sliderControlButtons.forEach(link => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    
    if (this.currentPage >= 1) {
      this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
      this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
    }
  }

  isSlideVisible(element, offset = 0) {
    if (this.sliderPage === 'pdp' && !this.isMobileSlider) {
      const lastVisibleSlideVertical = this.slider.clientHeight + this.slider.scrollTop - offset;
      return (element.offsetTop + element.clientHeight) <= lastVisibleSlideVertical && element.offsetTop >= this.slider.scrollTop;
    }
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;

    if (this.sliderPage === 'pdp' && !this.isMobileSlider) {
      this.slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollTop + (step * this.sliderItemOffset) : this.slider.scrollTop - (step * this.sliderItemOffset)
      this.slider.scrollTo({
        top: this.slideScrollPosition
      })
      return;
    }
    this.slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + (step * this.sliderItemOffset) : this.slider.scrollLeft - (step * this.sliderItemOffset);
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
    return;
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach(link => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach(link => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition = this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length) linkElements.forEach(button => {
          button.removeAttribute('tabindex');
        });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length) linkElements.forEach(button => {
          button.setAttribute('tabindex', '-1');
        });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);
class VariantSelects extends HTMLElement {  
  constructor() {
    super();
    this.updateStockIndicator();
    this.addEventListener('change', this.onVariantChange);
    window.addEventListener('load', this.moveToSetThumbnail.bind(this));
  }

  updateStockIndicator() {
    this.getVariantData()
    this.updateOptions()
    this.updateMasterId()
  }
  
  onVariantChange() {
    this.counter = 0;
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.moveToSetThumbnail();
    fetchBestProductDiscounts(this.currentVariant?.product?.id || this.currentVariant?.featured_image?.product_id || "", this.currentVariant?.id || "")
    cartValidation(this.currentVariant.sku)
    getShippingCalculated(null,this.currentVariant )
    window.updateFooterDiscount(variantInput?.currentVariant, false);
    window.updateMoreInfoSection();
    window.fetchStoreLocationInfo('', this.currentVariant.id);
    window.getCurrentVariantValues();
    window.constructImage(this.currentVariant?.featured_image);
    if (typeof window.setProductSpecification === 'function') {
      window.setProductSpecification(this.currentVariant.id);
    }
    if (typeof window.updateProductVariant === 'function') {
      window.updateProductVariant(this.currentVariant);
    }
    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
      hasColorOption && this.updateVariantColor();
    }
  }

  updateVariantColor () {
    const colorNameElement = document.querySelector('.selected-variant-color');
    const colorName = this.currentVariant['option' + colorOptionPosition];
    colorNameElement.innerHTML = colorName;
    this.getVariantData().find((variant) => {
      const variantColorName = variant['option' + colorOptionPosition]
      const variantColorNameElement = document.getElementById(variantColorName);
      if (colorName === variantColorName) {
        variantColorNameElement.classList.add('variant_input-value-color-selected')
      } else {
        variantColorNameElement.classList.add('variant_input-value-color')
        variantColorNameElement.classList.remove('variant_input-value-color-selected')
      }
    })
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  moveToSetThumbnail() {
    const allThumbnail = document.querySelectorAll('li[data-set-alt]');
    const variantOptions = this.currentVariant.options;
    const filteredThumbnail = Array.from(allThumbnail).filter(element => 
      variantOptions.map(opt => opt.toLowerCase()).includes(element.getAttribute('data-set-alt').toLowerCase()))?.[0] ?? null;
    if (!filteredThumbnail) {
      return;
    }
    const slider = document.querySelector('slider-component.thumbnail-slider-advanced ul');
    const top = filteredThumbnail.offsetTop;
    const left = filteredThumbnail.offsetLeft;
    filteredThumbnail.querySelector('button').click();
    const isMobile = window.matchMedia('(max-width: 749px)').matches;
    if (isMobile) {
      slider.scrollTo({
        left,
        behavior: 'smooth'
      });
    } else {
      slider.scrollTo({
        top,
        behavior: 'smooth'
      });
    }
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;
    const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`);
    mediaGalleries.forEach(mediaGallery => 
      mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, { setActiveThumbnailCentered: false })
    );
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;
    
    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  
  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(`price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        if (source && destination) destination.innerHTML = source.innerHTML;

        const price = document.getElementById(`price-${this.dataset.section}`);
        if (price) price.classList.remove('visibility-hidden');
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }
    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }

}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);

function parseRawDateToDate(rawDate,isShortMonth=false){
  var day = parseInt(rawDate.substring(0,2));
  var month = parseInt(rawDate.substring(2,4))-1;
  var year = parseInt(rawDate.substring(4,8));
  const preorderDate = new Date(year, month, day);
  if(isShortMonth){
    month=preorderDate.toLocaleString('id-ID', { month: 'short' });
  }else{
    month=preorderDate.toLocaleString('id-ID', { month: 'long' });
  }
  return preorderDate.toLocaleString('id-ID', { day: 'numeric' })+' '+month+' '+preorderDate.getFullYear();
}

function parseRawDateToDay(rawDate){
  var day = parseInt(rawDate.substring(0,2));
  var month = parseInt(rawDate.substring(2,4))-1;
  var year = parseInt(rawDate.substring(4,8));
  const preorderDate = new Date(year, month, day);
  
  return preorderDate.toLocaleString('id-ID', { weekday: 'long' });
}

function convertToRupiah(number, showTrailingZeros = true){
  const showDecimals = showTrailingZeros || !Number.isInteger(number);
  return new Intl.NumberFormat("id-ID", {
    style: "currency",
    currency: "IDR",
    maximumFractionDigits: showDecimals ? 2 : 0
  }).format(number);
}
async function getCartItemsGlobal(currentSku) {
  const res = await fetch('/cart.js', {
    method: 'GET',
    headers: { 'Content-Type': 'application/json' }
  })
  const resText = await res.text()
  const responseCart = JSON.parse(resText)
  if (responseCart && responseCart.items && responseCart.items.length) {
    return responseCart.items.map(item => item.sku).includes(currentSku)
  } else {
    return false
  }
}
async function getSku6MonthValidation (listOfSKU) {
  const customerId = document.getElementById("customerId")?.getAttribute('data-customer-id')
  const payload = {
    customerId: customerId,
    productSku: listOfSKU
  }
  const response = await fetch(
    `https://${env}/hello-gateway/hello-api/api/epp/isEligibleProduct`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Shopify-Shop-Domain": Shopify.shop.toString(),
        "X-Shopify-Hmac-Sha256": "EPP"
      },
      body: JSON.stringify(payload)
    }
  )
  if (response.ok) {
    const resText = await response.text()
    const responseValidation = JSON.parse(resText)
    const submitButton = document.querySelector('button[type="submit"]');
    if (responseValidation && responseValidation?.eligibleProducts) {
      submitButton.removeAttribute('disabled');
      submitButton.type = 'submit'
      return responseValidation?.eligibleProducts || []
    }
  } else {
    submitButton.setAttribute('disabled', "disabled");
    submitButton.type = 'button'
    return []
  }
}

const sku = document.getElementById('productSku')?.getAttribute('data-product-sku') 
const productID = document.getElementById('productID')?.getAttribute('data-product-id') 
const productVariantID = document.getElementById('selectedSku')?.getAttribute('data-selected-sku') 
const isFromPdp = document.getElementById('isFromPDP')?.getAttribute('data-from-pdp')
if(Boolean(isFromPdp)){
  cartValidation(sku)
  fetchBestProductDiscounts(productID,productVariantID)
}

async function cartValidation(sku) {
  const isB2B = document.getElementById("isB2B")?.getAttribute('data-customer-b2b') || false
  const eppErrorMessage = document.querySelector('#product-epp-error-message')
  const submitButton = document.getElementById('add-to-cart-button')
  submitButton.type = 'button'
  eppErrorMessage.classList.add('hidden');
  if (isB2B === 'true') {
    const isCartPresence = await getCartItemsGlobal(sku)
    const sku6MonthValidation = await getSku6MonthValidation([sku])
    if (isCartPresence || !sku6MonthValidation[0]?.eligible) {
      eppErrorMessage.classList.remove('hidden')
      submitButton.setAttribute('epp-disabled', '')
    } else {
      submitButton.removeAttribute('epp-disabled')
      submitButton.type = 'submit'
    }
  } else {
    submitButton.removeAttribute('epp-disabled')
    submitButton.type = 'submit'
  }
}
function debounce(func, wait) {
  let timeout;
  return function(...args) {
    const context = this;
    clearTimeout(timeout);
    timeout = setTimeout(() => func.apply(context, args), wait);
  };
}
async function fetchBestProductDiscounts(productID, productVariantID) {
  const discountsContainer = document.getElementById("pdp-discounts")
  discountsContainer.style.display = 'none';
  const customerId = document.getElementById("customerId")?.getAttribute('data-customer-id')
  const variantInput = document.querySelector('variant-radios')
  const price = variantInput?.currentVariant?.price || document.querySelector('.price')?.dataset?.price;
  const formattedPrice = Math.floor(price / 100);  
  const payload = {
    "customerId": customerId ? `gid://shopify/Customer/${customerId}` : null,
    "cartQuantity": 1,
    "cartPrice":formattedPrice,
    "productDetails": [
      {
        "productId": productID ? "gid://shopify/Product/" + productID : "",
        "variantId": productVariantID ? "gid://shopify/ProductVariant/" + productVariantID : "",
        "quantity": 1,
        "price":formattedPrice
      }
    ]
  };
  const response = await fetch(
    `https://${env}/hello-gateway/hello-api/api/discountCode/getEligibleOrderAndProductDiscountCodes`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Shopify-Shop-Domain": Shopify.shop.toString(),
        "X-Shopify-Hmac-Sha256": hmacKey
      },
      body: JSON.stringify(payload)
    }
  );
  if (response.ok) {
    const discount = await response.json()
    if (discount.success) {
      const bestProductDiscount = getBestProductDiscount(discount?.value?.discountResponseList)

      if (bestProductDiscount) {
        const { discountValueType, discountValue, title, endsAt } = bestProductDiscount
        let displayValue = formatDiscountValue(discountValueType, discountValue)
        const discountTemplate = generateDiscountTemplate(displayValue, title, endsAt)
        if (discountsContainer) {
          discountsContainer.style.display='flex'
          discountsContainer.innerHTML = discountTemplate
          const copyButton = document.getElementById("discount-copy")
          if (copyButton) {
            copyButton.addEventListener('click', () => {
              window.navigator.clipboard.writeText(title)
            })
          }
          if (endsAt) {
            initializeExpiryCountdown(endsAt, "expiry-timer")
          }
        }
      }
    }
  } else {
    console.error("Failed to fetch discounts:", response.status, await response.text())
  }
}

function getBestProductDiscount(discountList) {
  return discountList
    ?.filter(discount => discount.discountType === "productDiscount" && discount.eligible)
    ?.reduce((maxDiscount, currentDiscount) =>
      currentDiscount.calculatedDiscountValue > (maxDiscount?.calculatedDiscountValue || 0)
        ? currentDiscount
        : maxDiscount,
      null)
}

function formatDiscountValue(discountValueType, calculatedDiscountValue) {
  let formattedValue = ''
  if (discountValueType === "DiscountAmount") {
    formattedValue = convertToRupiah(calculatedDiscountValue, false)
  } else if (discountValueType === "DiscountPercentage") {
    formattedValue = `${calculatedDiscountValue * 100}%`
  }
  return formattedValue
}

function generateDiscountTemplate(displayValue, title, endsAt) {
  return `
      <div class="pdp-discounts-info">
          <div class="pdp-discounts-title">
              <span class="bold-text">Save ${displayValue}</span> with our discount code.
          </div>
          <div class="pdp-discounts-code">
              Code: ${title}
              <span id="discount-copy" class="bold-text"> Copy </span>
          </div>
          ${endsAt ? `
          <div class="pdp-discounts-expiry">
              Ends in <span class="bold-text" id="expiry-timer"></span>
          </div>` : ""}
      </div>
      <a class="pdp-discounts-icon" target="_blank" href="/pages/promosi-syarat-ketentuan"> </a>
    `
}

function calculateTimeRemaining(endsAt) {
  const now = new Date()
  const endTime = new Date(endsAt)
  const diff = endTime - now

  if (diff <= 0) {
    return ""
  }

  const totalHours = Math.floor(diff / (1000 * 60 * 60))
  const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60))
  const seconds = Math.floor((diff % (1000 * 60)) / 1000)
  const days = Math.floor(totalHours / 24)
  const hours = totalHours % 24

  if (totalHours < 24) {
    return `${hours.toString().padStart(2, "0")} : ${minutes
      .toString()
      .padStart(2, "0")} : ${seconds.toString().padStart(2, "0")}`
  } else {
    return `${days} day${days > 1 ? "s" : ""}`
  }
}

function initializeExpiryCountdown(endsAt, elementId) {
  function updateExpiry() {
    const expiryTime = calculateTimeRemaining(endsAt)
    document.getElementById(elementId).textContent = expiryTime
  }
  updateExpiry()
  setInterval(updateExpiry, 1000)
}
// Carousel controls common function
// Use Default id="cards-wrapper" data-id="{{ section.id }}" for cards wrapper

/* {% render 'carousel-controls-v2',
   section_id: section.id,
 %} */

const cardsWrapper = document.querySelectorAll("#cards-wrapper");
const controlsContainer = document.querySelectorAll(".carousel-controls");

cardsWrapper.forEach((wrapper) => {
  const wrapperDataId = wrapper.getAttribute("data-id");

  const matchingControl = [...controlsContainer].find(
    (control) => control.getAttribute("data-id") === wrapperDataId
  );
  if (matchingControl) {
    initializeCarousel(wrapper, matchingControl);
  } else {
    console.warn(`No matching control found for wrapper with data-id: ${wrapperDataId}`);
  }
});

function initializeCarousel(wrapper, controls) {
  const prevBtn = controls.querySelector(".control-btn:nth-child(1)");
  const nextBtn = controls.querySelector(".control-btn:nth-child(2)");

  const updateButtonStates = () => {
    const isScrollable = wrapper.scrollWidth > wrapper.clientWidth;
    controls.style.display = isScrollable ? "flex" : "none";
    wrapper.classList.toggle("align-center", !isScrollable);

    const atStart = wrapper.scrollLeft <= 0;
    const atEnd = wrapper.scrollLeft + wrapper.clientWidth >= wrapper.scrollWidth;

    prevBtn.classList.toggle("disabled", atStart);
    nextBtn.classList.toggle("disabled", atEnd);
  };
  const scrollCards = (direction) => {
    const scrollAmount = Math.min(wrapper.clientWidth, 380);
    wrapper.scrollBy({
      left: direction * scrollAmount,
      behavior: "smooth",
    });
  };

  prevBtn.addEventListener("click", () => !prevBtn.classList.contains("disabled") && scrollCards(-1));
  nextBtn.addEventListener("click", () => !nextBtn.classList.contains("disabled") && scrollCards(1));
  wrapper.addEventListener("scroll", updateButtonStates);
  window.addEventListener("resize", updateButtonStates);

  updateButtonStates();
}
